export const GIT_INTEGRATION_BASE_PATH = '/git_integration/v1';
